import type { Cartridge } from "./Cartridge"
import type { Cpu6502 } from "./Cpu6502"
import type { Ppu2C02 } from "./Ppu2C02"
import { u8 } from "./utils"

export class Bus {
    cpuRam = new Uint8Array(2 * 1024)
    cartridge!: Cartridge
    controller = new Uint8Array(2)

    private systemClockCounter = 0
    private controllerState = new Uint8Array(2)

    private dmaPage = 0x00
    private dmaAddress = 0x00
    private dmaData = 0x00

    private dmaDummy = true
    private dmaTransfer = false

    constructor(
        public cpu: Cpu6502,
        public ppu: Ppu2C02,
    ) {
        this.cpu.connectBus(this)
    }

    cpuWrite(address: number, data: number) {
        if (this.cartridge.cpuWrite(address, data)) {
        } else if (address >= 0x0000 && address <= 0x1fff) {
            this.cpuRam[address & 0x07ff] = data
        } else if (address >= 0x2000 && address <= 0x3fff) {
            this.ppu.cpuWrite(address & 0x0007, data)
        } else if (address === 0x4014) {
            this.dmaPage = data
            this.dmaAddress = 0x00
            this.dmaTransfer = true
        } else if (address >= 0x4016 && address <= 0x4017) {
            this.controllerState[address & 0x0001] = this.controller[address & 0x0001]!
        }
    }

    cpuRead(address: number) {
        let data = this.cartridge.cpuRead(address)

        if (data !== undefined) {
        } else if (address >= 0x0000 && address <= 0x1fff) {
            data = this.cpuRam[address & 0x07ff]!
        } else if (address >= 0x2000 && address <= 0x3fff) {
            data = this.ppu.cpuRead(address & 0x0007)
        } else if (address >= 0x4016 && address <= 0x4017) {
            data = Number((this.controllerState[address & 0x0001]! & 0x80) > 0)
            this.controllerState[address & 0x0001]! <<= 1
        }

        return data || 0x00
    }

    insertCartridge(cartridge: Cartridge) {
        this.cartridge = cartridge
        this.ppu.connectCartridge(cartridge)
    }

    reset() {
        this.cartridge.reset()
        this.cpu.reset()
        this.ppu.reset()
        this.systemClockCounter = 0
        this.dmaPage = 0x00
        this.dmaAddress = 0x00
        this.dmaData = 0x00
        this.dmaDummy = true
        this.dmaTransfer = false
    }

    clock() {
        this.ppu.clock()

        if (this.systemClockCounter % 3 == 0) {
            if (!this.dmaTransfer) this.cpu.clock()
            else {
                if (this.dmaDummy) {
                    if (this.systemClockCounter % 2 === 1) this.dmaDummy = false
                } else {
                    if (this.systemClockCounter % 2 === 0) {
                        this.dmaData = this.cpuRead((this.dmaPage << 8) | this.dmaAddress)
                    } else {
                        this.ppu.oam[this.dmaAddress] = this.dmaData
                        this.dmaAddress = u8(this.dmaAddress + 1)
                        if (this.dmaAddress === 0x00) {
                            this.dmaTransfer = false
                            this.dmaDummy = true
                        }
                    }
                }
            }
        }

        if (this.ppu.nmi) {
            this.ppu.nmi = false
            this.cpu.nonMaskableInterruptRequest()
        }

        this.systemClockCounter++
    }
}
